import styled from 'styled-components';
import { device } from './responsives';


export const NavBarContainer = styled.div`
  height: 72px;
  display: inline-block;
  width: 100%;
  position: relative;

  @media ${device.maxlaptop}{
    height: auto;
    padding: 12px 0px;
  }

  @media ${device.mobileL}{
    padding-left: 0px;
  }
`

export const NavUl = styled.ul`
  @media ${device.minlaptop}{
    display: inline-block;
    padding-left: 48px;
    opacity: 0.8;
    background-color: clear;
    margin: 0px;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
  }

  @media ${device.maxlaptop}{
    margin: 0px;
    display: block;
    padding-left: 60px;
  }

  @media ${device.mobileL}{
    margin-left: 16px;
    margin-right: 16px;
    padding-left: 0px;
  }
`

export const NavLi = styled.li`
  &:hover {
    background-color: #d6d6d6;
    border-radius: 2px;
  }
  display: inline-block;
  text-decoration: none;
  padding: 12px;
  font-family: Avenir-Roman;
  font-size: 20px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;

  ${({selection, name}) => (selection === name) && `
    text-decoration: underline;
  `}
`

export const NavLiJourney = styled(NavLi)`
  border-color: #4a4a4a;
`
